import { Get, Post } from 'api/index'

export const LIST_FILTERS = 'LIST_FILTERS'
export const SET_CURRENT_SEARCHABLE = 'SET_CURRENT_SEARCHABLE'
export const UPDATE_SELECTED_FILTERS = 'UPDATE_SELECTED_FILTERS'
export const UPDATE_PROGRAMME_FILTERS = 'UPDATE_PROGRAMME_FILTERS'
export const TOGGLE_FILTER_SUBMIT = 'TOGGLE_FILTER_SUBMIT'
export const LIST_REGIONS = 'LIST_REGIONS'
export const GET_REGIONS = 'GET_REGIONS'
export const GET_PARTNER_COVERAGE_BY_REGION = 'GET_PARTNER_COVERAGE_BY_REGION'
export const LIST_PROGRAMMES = 'LIST_PROGRAMMES'
export const SET_RESULT_HASH = 'SET_RESULT_HASH'

export const filtersList = params => dispatch => {
  const url = `/api/available-filters/`
  return dispatch({
    type: LIST_FILTERS,
    payload: Get(url, params)
  })
}

export const regionsList = params => dispatch => {
  const url = `/api/search/regions/`
  return dispatch({
    type: LIST_REGIONS,
    payload: Get(url, params)
  })
}

export const getRegionsAsList = params => dispatch => {
  const url = `/api/search/regions/`
  return dispatch({
    type: GET_REGIONS,
    payload: Get(url, params)
  })
}

export const getPartnerCoverageByRegion = params => dispatch => {
  const url = `/api/partner/partner_coverage_by_region/`
  return dispatch({
    type: GET_PARTNER_COVERAGE_BY_REGION,
    payload: Post(url, JSON.stringify(params))
  })
}

export const programmesList = params => dispatch => {
  const url = `/api/programme/`
  return dispatch({
    type: LIST_PROGRAMMES,
    payload: Get(url, params)
  })
}

export const setCurrentSearchable = data => dispatch =>
  dispatch({
    type: SET_CURRENT_SEARCHABLE,
    payload: data
  })

export const updateSelectedFilters = data => dispatch =>
  dispatch({
    type: UPDATE_SELECTED_FILTERS,
    payload: data
  })

export const updateProgrammeFilters = data => dispatch =>
  dispatch({
    type: UPDATE_PROGRAMME_FILTERS,
    payload: data
  })

export const toggleFilterSubmit = data => dispatch =>
  dispatch({
    type: TOGGLE_FILTER_SUBMIT,
    payload: data
  })

export const setResultHash = data => dispatch =>
  dispatch({
    type: SET_RESULT_HASH,
    payload: data
  })
